$(document).ready(function(){
  // #upsell_slider on theme.js 5874 line and 5826
  $(document).on('click','.mini-cart button.upsell_btn',function(){
    console.log('hh');
    $(this).addClass('loading');
    var id = $(this).data('pro-id');
    console.log(id);
    var arrPdp = [];
    if(id != ''){    
      $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: id
      },
      dataType: 'json', 
      success: function (data) { 
        $('.mini-cart button.upsell_btn').removeClass('loading');
        // document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: data
        }));  
        
       } 
      });
    }
  });  
  if($('body').hasClass('template-product')){
     $(document).find('.template-product #upsell_slider').slick({
          infinite: false,
          slidesToShow: 1.4,
          slidesToScroll: 1,
          arrows:false
        });
    
   $(document).on('click','.product__info button.upsell_btn',function(){
    console.log('pro');
     $(this).addClass('loading');
    var id = $(this).data('pro-id');
    console.log(id);
    var arrPdp = [];
    if(id != ''){    
      $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: id
      },
      dataType: 'json', 
      success: function (data) { 
        
        // document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: data
        })); 
        var cartDrawerButtonSelector = "a.header__icon-wrapper[aria-controls='mini-cart']";
        var cartDrawerButton = document.querySelector(cartDrawerButtonSelector);
        setTimeout(function() {
        cartDrawerButton.click();
        $('.product__info button.upsell_btn').removeClass('loading');
        }, 1000);
       } 
      });
    }
  });
  }


  // $('.shopify-section--product-recommendations .product-list__inner').slick({
  //   infinite: false,
  //   dots: true,
  //   arrows: false,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   responsive: [
  //   {
  //     breakpoint: 1200,
  //     settings: {
  //       slidesToShow: 2.4,
  //       slidesToScroll: 1
  //     }
  //   },
  //   {
  //     breakpoint: 768,
  //     settings: {
  //       slidesToShow: 1.4,
  //       slidesToScroll: 1
  //     }
  //   }
  // ]
  // });
  
});

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".playbutton").forEach(function(wrapper) {
    const video = wrapper.querySelector("video");
    if (!video) return;

    // Create overlay button
    const overlay = document.createElement("div");
    overlay.className = "custom-play-overlay";
    overlay.innerHTML = "&#9658;"; // play triangle
    wrapper.appendChild(overlay);

    overlay.addEventListener("click", function() {
      video.play();
      overlay.style.display = "none"; // hide after play
    });

    // Optional: hide overlay if user uses native controls
    video.addEventListener("play", function() {
      overlay.style.display = "none";
    });
    video.addEventListener("pause", function() {
      overlay.style.display = "block";
    });
  });
});




// Add "FAQ" tab to BOTH desktop and mobile; scroll to .faq with offset (-200 desktop, -100 mobile)
document.addEventListener("DOMContentLoaded", () => {
  const faqSection = document.querySelector(".faq");
  if (!faqSection) return;

  const OFFSET_DESKTOP = 300;
  const OFFSET_MOBILE = 200;

  const scrollToFaq = () => {
    const rect = faqSection.getBoundingClientRect();
    const top = window.scrollY + rect.top;
    const offset = window.innerWidth > 768 ? OFFSET_DESKTOP : OFFSET_MOBILE;
    window.scrollTo({ top: top - offset, behavior: "smooth" });
  };

  // ---------- DESKTOP TAB ----------
  (function addDesktopTab() {
    const tabsList = document.querySelector(".tabs-nav__item-list");
    if (!tabsList || document.getElementById("faq-desktop-btn")) return;

    const btn = document.createElement("button");
    btn.id = "faq-desktop-btn";
    btn.type = "button";
    btn.className = "tabs-nav__item heading heading--small";
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-controls", "gotofaq");
    btn.textContent = "FAQ";

    tabsList.appendChild(btn);

    btn.addEventListener("click", () => {
      // mirror active state like other tabs
      tabsList.querySelectorAll(".tabs-nav__item").forEach(el => el.setAttribute("aria-expanded", "false"));
      btn.setAttribute("aria-expanded", "true");
      scrollToFaq();
      // optional: reset after a moment so tab styles return if needed
      setTimeout(() => btn.setAttribute("aria-expanded", "false"), 400);
    });
  })();

  // ---------- MOBILE TAB ----------
  (function addMobileTab() {
    const mobileTabsContent = document.querySelector(".product-tabs__content");
    if (!mobileTabsContent || document.getElementById("faq-mobile-tab-wrapper")) return;

    const wrapper = document.createElement("div");
    wrapper.id = "faq-mobile-tab-wrapper";
    wrapper.className = "product-tabs__tab-item-wrapper";
    wrapper.hidden = true; // match the hidden wrappers pattern

    const btn = document.createElement("button");
    btn.setAttribute("is", "toggle-button");
    btn.className = "collapsible-toggle heading heading--small hidden-lap-and-up";
    btn.setAttribute("aria-controls", "faq-mobile-content");
    btn.setAttribute("aria-expanded", "false");
    btn.textContent = "FAQ";

    const coll = document.createElement("collapsible-content");
    coll.id = "faq-mobile-content";
    coll.className = "collapsible";
    const inner = document.createElement("div");
    inner.className = "product-tabs__tab-item-content";
    coll.appendChild(inner);

    wrapper.appendChild(btn);
    wrapper.appendChild(coll);
    mobileTabsContent.appendChild(wrapper);

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      btn.setAttribute("aria-expanded", "true");
      scrollToFaq();
      setTimeout(() => btn.setAttribute("aria-expanded", "false"), 400);
    });
  })();
});

// LB: Flaggen-Emoji aus dem Land/Währungs-Trigger im Header entfernen (nur Text "DE | €" bleibt)
(function () {
  function lbStripFlag() {
    var el = document.getElementById('currencydesktop');
    if (!el) return;
    el.textContent = el.textContent.replace(/[\u{1F1E6}-\u{1F1FF}]/gu, '').replace(/\s+/g, ' ').trim();
    el.classList.add('lb-flag-stripped');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lbStripFlag);
  else lbStripFlag();
})();
/* LB Warenkorb Neu: echte Versandkosten je Land automatisch setzen */
(function () {
  var ZIP = { DE: '10115', AT: '1010', CH: '8001', LI: '9490', NL: '1011 AB', BE: '1000', LU: '1009', FR: '75001', IT: '00118', ES: '28001', PT: '1000-001', PL: '00-001', CZ: '110 00', SK: '811 01', HU: '1011', SI: '1000', HR: '10000', RO: '010011', BG: '1000', GR: '105 57', DK: '1050', SE: '111 20', NO: '0150', FI: '00100', IS: '101', EE: '10111', LV: '1050', LT: '01100', IE: 'D01 F5P2', GB: 'SW1A 1AA', MT: 'VLT 1000', CY: '1010', MC: '98000', US: '10001', CA: 'K1A 0B1', AU: '2000', NZ: '6011', JP: '100-0001', IL: '9100000', SG: '018956', BA: '71000', BM: 'HM 08', CN: '100000', FO: '100', GE: '0105', GG: 'GY1 1AA', ID: '10110', IM: 'IM1 1AA', IN: '110001', KR: '04524', ME: '81000', MK: '1000', MY: '50000', PH: '1000', RE: '97400', RS: '11000', SM: '47890', TH: '10200', VG: 'VG1110', VN: '100000', ZA: '2000', TR: '34000', TW: '100', SA: '11564', TN: '1000', MA: '10000', DZ: '16000', LK: '00100', LA: '01000', OM: '100', KW: '13001', LB: '1100', KY: 'KY1-1000', AL: '1001', DO: '10101', AI: 'AI-2640', EG: '11511' };
  var PROV = { US: 'NY', CA: 'ON', AU: 'NSW', JP: 'JP-13', ES: 'M', IT: 'RM', PT: 'PT-11', IE: 'D', RO: 'B', AE: 'DU', CN: 'BJ', EG: 'C', HK: 'HK', ID: 'JK', IN: 'DL', KR: 'KR-11', KW: 'KU', MY: 'KUL', PH: 'PH-00', TH: 'TH-10', ZA: 'GP' };
  var cache = {};
  var busy = false;

  var css = document.createElement('style');
  css.textContent = '.lb-cn-foot .lb-cn-row:not([data-lb-ship]) .lb-cn-free,.lb-cn-foot:not([data-lb-ship]) .lb-cn-row--total span:last-child{visibility:hidden}';
  (document.head || document.documentElement).appendChild(css);

  function country() {
    return (window.Shopify && Shopify.country) || 'DE';
  }

  function fmt(cents, sample) {
    var num = (cents / 100).toFixed(2);
    if (/\d,\d{2}(?!\d)/.test(sample)) num = num.replace('.', ',');
    return sample.replace(/\d[\d.,'\s]*\d/, num);
  }

  function getRate(c, total) {
    var key = c + '_' + total;
    if (cache[key] !== undefined) return Promise.resolve(cache[key]);
    var url = '/cart/shipping_rates.json?shipping_address[country]=' + c +
      '&shipping_address[zip]=' + encodeURIComponent(ZIP[c] || '') +
      '&shipping_address[province]=' + encodeURIComponent(PROV[c] || '');
    return fetch(url).then(function (r) { return r.json(); }).then(function (j) {
      var rates = (j && j.shipping_rates) || [];
      var min = null;
      rates.forEach(function (x) {
        var p = Math.round(parseFloat(x.price) * 100);
        if (min === null || p < min) min = p;
      });
      cache[key] = min;
      return min;
    }).catch(function () { return null; });
  }

  function update() {
    var foot = document.querySelector('.lb-cn-foot');
    if (!foot || busy) return;
    var row = foot.querySelector('.lb-cn-row--ship');
    if (!row || row.getAttribute('data-lb-ship') === 'done') return;
    var val = row.querySelector('.lb-cn-free');
    var totalEl = foot.querySelector('.lb-cn-row--total span:last-child');
    if (!val || !totalEl) return;
    busy = true;
    var en = (document.documentElement.lang || '').indexOf('en') === 0;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      return getRate(country(), cart.total_price).then(function (rate) {
        var sample = totalEl.textContent.trim();
        if (rate === null) {
          val.textContent = ({ en: 'Calculated at checkout', es: 'Se calcula al pagar', fr: 'Calculé au paiement', it: 'Calcolato al pagamento' })[(document.documentElement.lang || '').slice(0, 2)] || 'Wird an der Kasse berechnet';
          totalEl.textContent = fmt(cart.total_price, sample);
        } else if (rate === 0) {
          val.textContent = ({ en: 'Free for you', es: 'Gratis para ti', fr: 'Offerte', it: 'Gratis per te' })[(document.documentElement.lang || '').slice(0, 2)] || 'Gratis für Dich';
          totalEl.textContent = fmt(cart.total_price, sample);
        } else {
          val.textContent = fmt(rate, sample);
          totalEl.textContent = fmt(cart.total_price + rate, sample);
        }
      });
    }).catch(function () {}).finally(function () {
      row.setAttribute('data-lb-ship', 'done');
      foot.setAttribute('data-lb-ship', 'done');
      busy = false;
      setTimeout(update, 50);
    });
  }

  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(update, 100);
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', update);
})();

/* LB Warenkorb Neu: alten Focal-Drawer (#mini-cart) stilllegen, stattdessen neuen Warenkorb öffnen */
(function () {
  var st = document.createElement('style');
  st.textContent = '#mini-cart{display:none!important;visibility:hidden!important}';
  (document.head || document.documentElement).appendChild(st);

  function patch(el) {
    if (!el || el.__lbPatched) return;
    el.__lbPatched = true;
    try {
      Object.defineProperty(el, 'open', {
        configurable: true,
        get: function () { return false; },
        set: function (v) {
          if (v && window.lbCartNew && window.lbCartNew.open) {
            setTimeout(function () { window.lbCartNew.open(); }, 0);
          }
        }
      });
    } catch (e) {}
    if (el.hasAttribute('open')) el.removeAttribute('open');
  }

  function run() { patch(document.getElementById('mini-cart')); }
  run();
  document.addEventListener('DOMContentLoaded', run);
  new MutationObserver(function () {
    var el = document.getElementById('mini-cart');
    if (el && !el.__lbPatched) patch(el);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
/* LB Warenkorb Neu: Wechselkurs fuer Geschenk-Schwellen in Fremdwaehrung an den Warenkorb geben */
(function () {
  function run() {
    try {
      var cur = window.Shopify && Shopify.currency;
      if (!cur || !cur.rate) return;
      var rate = String(cur.rate);
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var have = (c.attributes && c.attributes._lb_rate) || '';
        if (cur.active !== c.currency || have === rate) return;
        if (!have && (rate === '1.0' || rate === '1')) return;
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _lb_rate: rate } }) }).then(function () {
          if (window.lbCartNew && lbCartNew.refresh) lbCartNew.refresh(true);
        });
      }).catch(function () {});
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
